var MESSAGES = {
    NOT_FOUND:
      'Sorry, but the resource that you are trying to recover is not available anymore!',
    INVALID:
      'One or more fields have invalid values. Specify valid ones and try again.',
    INTERNAL_ERROR: 'An error occurred. Please contact support.',
    FORBIDDEN_DELETE_ROLE:
      'This Role cannot be deleted when used by a Node Group.',
  },
  Errors = {
    NOT_FOUND: 404,
    INVALID: 422,
    INTERNAL_ERROR: 500,
    FORBIDDEN_DELETE_GROUP_ROLE: 432,

    getMessage: function (statusCode) {
      var message = MESSAGES[this._getStatusName(statusCode)];

      if (!message) {
        message = MESSAGES.INTERNAL_ERROR;
      }

      return message;
    },

    _getStatusName: function (statusCode) {
      switch (statusCode) {
        case Errors.NOT_FOUND:
          return 'NOT_FOUND';
        case Errors.INVALID:
          return 'INVALID';
        case Errors.FORBIDDEN_DELETE_GROUP_ROLE:
          return 'FORBIDDEN_DELETE_ROLE';
        default:
          return 'INTERNAL_ERROR';
      }
    },
  };

module.exports = Errors;
